import {PERMISSION_TYPE} from '@/Permissions';

type SlotCheck = (value: unknown) => boolean;

export const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const isNonEmptyString: SlotCheck = value => typeof value === 'string' && value.trim().length > 0;

const isAgentText: SlotCheck = value => isRecord(value) && isNonEmptyString(value.id) && isNonEmptyString(value.defaultMessage);

const isFunction: SlotCheck = value => typeof value === 'function';

const isNonEmptyStringList: SlotCheck = value => Array.isArray(value) && value.length > 0 && value.every(isNonEmptyString);

const isAppPath: SlotCheck = value => typeof value === 'string' && value.startsWith('/');

const isPermission: SlotCheck = value => (Object.values(PERMISSION_TYPE) as readonly unknown[]).includes(value);

const DECLARATION_SLOT_CHECKS: ReadonlyArray<[string, SlotCheck]> = [
	['id', isNonEmptyString],
	['name', isAgentText],
	['pages', isNonEmptyStringList],
	['rows', isNonEmptyStringList],
	['recordNoun', isAgentText],
	['permission', isPermission],
	['action', isAgentText],
	['resultNoun.singular', isAgentText],
	['resultNoun.plural', isAgentText],
	['acceptLabel.single', isAgentText],
	['acceptLabel.bulk', isAgentText],
	['runAgainLabel', isAgentText],
	['runAgainToast', isAgentText],
	['doneStateName', isAgentText],
	['doneAction.label', isAgentText],
	['doneAction.perform', isFunction],
	['rowActionTips.idle', isAgentText],
	['rowActionTips.working', isAgentText],
	['rowActionTips.ready', isAgentText],
	['describeResult', isFunction],
	['foundText', isFunction],
	['summaryToast', isFunction],
	['describeNotification', isFunction],
	['failureReason', isFunction],
	['review', isFunction],
	['schedulingTarget', isNonEmptyString],
	['homePagePath', isAppPath],
];

export const DECLARATION_SLOT_PATHS: string[] = DECLARATION_SLOT_CHECKS.map(([slotPath]) => slotPath);

const readSlot = (source: unknown, slotPath: string): unknown =>
	slotPath.split('.').reduce<unknown>((current, key) => (isRecord(current) ? current[key] : undefined), source);

export const validateAgentDeclaration = (candidate: unknown): string[] =>
	DECLARATION_SLOT_CHECKS.filter(([slotPath, check]) => !check(readSlot(candidate, slotPath))).map(([slotPath]) => slotPath);
